import { gql } from '@apollo/client';

const FETCH_CLIENTS = gql`
  query SearchUsers($input: UserSearchInput!) {
    searchUsers(input: $input) {
      users {
        id
        firstName
        lastName
      }
    }
  }
`;

const FETCH_PORTFOLIO_REPORTS = gql`
  query fetchPortfolioReports($input: FetchPortfolioReportsInput!) {
    fetchPortfolioReports(input: $input) {
      portfolioReports {
        driftRebalanceRequired
        expectedCashCents
        cashAvailableForTradeCents
        state
        unverifiedSubTradeRequests
        pendingCashCents
        holdings {
          expectedValueCents
          expectedPercentage
          pendingQuantity
          financialProduct {
            id
            ticker
            isCash
            currentPriceCents
            name
            taxRank
            translatedName {
              en
              fr
            }
          }
        }
        id
        liquidateRebalanceRequired
        transferRebalanceRequired
        pendingSubTradeRequests
        modelPortfolio {
          id
          translatedName {
            en
            fr
          }
        }
        updatedAt
        lastOptimizedBy {
          id
          createdAt
        }
        subAccounts {
          subAccount {
            id
            state
            account {
              taxRank
              type
              user {
                firstName
              }
            }
          }
          expectedCashCents
          cashAvailableForTradeCents
          marketValueCents
          pendingWithdrawCents
          pendingCashCents
        }
        modelPortfolioType
        bulkTradeRunReasons {
          reason
          total
          unblockedSince
        }
        object {
          ... on Goal {
            id
            type
            statistics {
              marketValueCents
            }
            __typename
            name
            user {
              id
              firstName
              lastName
              entityName
              organization {
                name
              }
            }
            householdClientGroup {
              id
              name
            }
          }
          ... on SubAccount {
            id
            __typename
            statistics {
              marketValueCents
            }
            goal {
              id
              name
              type
              householdClientGroup {
                id
                name
              }
            }
            account {
              id
              type
              user {
                id
                firstName
                lastName
                entityName
                organization {
                  name
                }
              }
            }
          }
        }
      }
      totalCount
    }
  }
`;

const FETCH_SUBTRADES_REQUESTS = gql`
  query FetchSubTradeRequests($input: FetchSubTradeRequestsInput!) {
    fetchSubTradeRequests(input: $input) {
      totalCount
      subTradeRequests {
        actualQuantity
        actualTradePriceCents
        blockedUntil
        blockedUntilAccountActive
        blockedUntilPairActualTradePriceCents
        blockedUntilSubAccountActive
        createdAt
        currency
        exchange
        expectedQuantity
        expectedTradePriceCents
        id
        isPartial
        isProcessedForPair
        isSellAll
        isSuggestedByOptimizer
        maxQuantity
        moneyAllocatedCents
        portfolioReport
        preSplitMoneyAllocatedCents
        settlementDate
        settlementDays
        sourceId
        state
        stateChanges
        ticker
        type
        updatedAt
        verifiedAt
        verifiedBy
        volatile
        account {
          custodianAccountName
          translatedNickName {
            en
            fr
          }
        }
        user {
          id
          firstName
          lastName
        }
        subAccount {
          id
          name
          account {
            id
            type
            user {
              id
              entityName
              firstName
            }
          }
          goal {
            id
            name
            type
          }
        }
        financialProduct {
          ticker
          translatedName {
            en
            __typename
          }
        }
      }
    }
  }
`;

export {
  FETCH_PORTFOLIO_REPORTS, FETCH_SUBTRADES_REQUESTS, FETCH_CLIENTS,
};
